<div [hidden]="!isVisible()" class="card mainpanel">
  <hs-panel-header name="adjuster" [title]="'ADJUSTER.adjustFactors' | translateHs: {app: 'default'} "></hs-panel-header>
  <div class="card-body">
    <div class="p-2 center-block">
      <div class="d-flex flex-row">
        <div>
          <button type="button" class="btn btn-primary btn-lg" (click)="adjusterService.apply()"
            [disabled]="adjusterService.isInProcess() || noDataSelected() || noOperationSelected() ">{{'ADJUSTER.calculate' | translateHs: {app: 'default'} }}</button>
        </div>
        <div class="ps-1 ps-sm-3">
          <button type="button" class="btn btn-sm btn-light hs-lm-item-visibility"
            [ngClass]="adjusterService.allowIndex ? 'hs-checkmark' : 'hs-uncheckmark'"
            (click)="adjusterService.allowIndex = !adjusterService.allowIndex; $event.stopPropagation()"></button>
          <label class="pl-2 text-secondary" [ngClass]="adjusterService.allowIndex ? 'fw-bold' : 'fw-normal'">
            {{'ADJUSTER.index' | translateHs: {app: 'default'} }}
          </label>
          <p class="text-secondary text-justify fst-italic">{{'ADJUSTER.indexDescription' | translateHs: {app: 'default'} }}</p>
        </div>
        <div class="ps-1 ps-sm-3">
          <button type="button" class="btn btn-sm btn-light hs-lm-item-visibility"
            [ngClass]="adjusterService.allowClusters ? 'hs-checkmark' : 'hs-uncheckmark'"
            (click)="adjusterService.allowClusters = !adjusterService.allowClusters; $event.stopPropagation()"></button>
          <label class="pl-2 text-secondary" [ngClass]="adjusterService.allowClusters ? 'fw-bold' : 'fw-normal'">
            {{'ADJUSTER.clusters' | translateHs: {app: 'default'} }}
          </label>
          <p class="text-secondary text-justify fst-italic">{{'ADJUSTER.clustersDescription' | translateHs: {app: 'default'} }}</p>
        </div>
      </div>
      <div class="text-warning pt-2" [hidden]="!noDataSelected() || errorMsg">{{'ADJUSTER.noDataSelectedMsg' | translateHs: {app: 'default'} }}</div>
      <div class="text-danger pt-2" [hidden]="!errorMsg">{{'ADJUSTER.serverError' | translateHs: {app: 'default'} }}: {{errorMsg}}</div>
    </div>
    <div class="p-2 center-block" [hidden]="!adjusterService.allowClusters">
      <div class="pt-2 text-secondary">{{'ADJUSTER.numberOfClusters' | translateHs: {app: 'default'} }}: {{adjusterService.numberOfClusters}}</div>
      <input type="range" class="form-range" [(ngModel)]="adjusterService.numberOfClusters" min="5" max="15" step="1">
    </div>
    <div class="p-2 center-block">
      <p class="my-1">{{'ADJUSTER.myRoleIs' | translateHs: {app: 'default'} }}:&emsp;</p>
      <select class="form-select mb-1 mb-sm-2" [(ngModel)]="adjusterPresetsService.activeRole" (ngModelChange)="adjusterPresetsService.pickProblem($event)">
        <option *ngFor="let role of adjusterPresetsService.roles" [ngValue]="role">{{getLabelInCurrentLang(role.labels)}}</option>
      </select>
      <p class="my-1">{{'ADJUSTER.myProblemIs' | translateHs: {app: 'default'} }}:&emsp;</p>
      <select class="form-select" [(ngModel)]="adjusterPresetsService.activeProblem" (ngModelChange)="adjusterPresetsService.applyProblem($event)">
        <option *ngFor="let problem of adjusterPresetsService.getActiveRoleProblems()" [ngValue]="problem">{{getLabelInCurrentLang(problem.labels)}}</option>
      </select>
    </div>
    <div class="pt-3 center-block">
      <button type="button" class="btn btn-primary btn-sm" [disabled]="adjusterService.isInProcess()"
        (click)="hsLayoutService.setMainPanel('adjuster-simple', 'default');$event.preventDefault();">
        <span class="glyphicon cursor-pointer" class="icon-chevron-left"></span>
        {{'ADJUSTER.simple' | translateHs: {app: 'default'} }}
      </button>
    </div>
    <!--button class="btn btn-light btn-sm" aria-expanded="false" aria-controls="advancedOptions" (click)="showAdvancedOptions = !showAdvancedOptions">
      <span class="glyphicon cursor-pointer" [ngClass]="showAdvancedOptions ? 'icon-chevron-down' : 'icon-chevron-right'"></span>
      {{'ADJUSTER.moreOpts' | translateHs: {app: 'default'} }}
    </button-->
    <div class="p-2 center-block">
      {{'ADJUSTER.classifyBySchema' | translateHs: {app: 'default'} }}:&emsp;
      <select class="form-select" [(ngModel)]="adjusterPresetsService.activeSchema" (ngModelChange)="adjusterPresetsService.changeSchema($event)">
        <option *ngFor="let schema of adjusterPresetsService.schemas" [ngValue]="schema">{{getLabelInCurrentLang(schema.labels)}}</option>
      </select>
    </div>
    <div *ngFor="let factor of adjusterService.factors">
      <pra-dataset-list [factor]="factor" *ngIf="hasDatasets(factor)"></pra-dataset-list>
    </div>
    <hr>
    <div [hidden]="!adjusterService.allowIndex" class="pb-2">
      <p class="lead">{{ 'ADJUSTER.indexLegend' | translateHs: {app: 'default'} }}</p>
      <div class="d-flex pb-1">
        <div *ngFor="let category of adjusterLegendService.staticIndexLegend" class="flex-grow-1">
          <div [ngStyle]="{'background-color': category}">&nbsp;</div>
        </div>
      </div>
      <div class="d-flex">
        <div class="flex-grow-1 text-start">{{ 'ADJUSTER.index0' | translateHs: {app: 'default'} }}</div>
        <div class="flex-grow-1">&nbsp;</div>
        <div class="flex-grow-1 text-end">{{ 'ADJUSTER.index100' | translateHs: {app: 'default'} }}</div>
      </div>
    </div>
    <div [hidden]="!adjusterService.allowClusters" class="pb-2">
      <p class="lead">{{ 'ADJUSTER.clusterLegend' | translateHs: {app: 'default'} }}</p>
      <div class="container">
        <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4">
          <div *ngFor="let color of adjusterLegendService.staticClusterLegend; let i = index" class="col">
            <div style="background-color: {{color}}" class="cluster-id text-center p-1 py-sm-3 my-1 my-sm-2">#{{i+1}}</div>
          </div>
        </div>
      </div>
    </div>
    <!--hr>
    <form role="form" class="pt-3 form" [hidden]="!adjusterService.clustersLoaded()">
      <div class="form-group">
        <div class="input-group">
          <label class="text-center">Display clusters calculated by method</label>
          <div>
            <select class="form-control" [(ngModel)]="method" (ngModelChange)="selectMethod()" name="method"
              [value]="method">
              <option *ngFor="let method of adjusterService.methods" [value]="method.codename">{{method.name}}
              </option>
            </select>
          </div>
        </div>
        <small class="text-justify text-info">REMEMBER: Not all clustering methods will provide meaningful results. Always
          take the output with a grain of salt.</small>
      </div>
    </form-->
    <hr>
    <div class="pt-3 center-block" [hidden]="adjusterService.isInProcess()">
      {{'ADJUSTER.layerManagerLink1' | translateHs: {app: 'default'} }}<br>
      {{'ADJUSTER.layerManagerLink2' | translateHs: {app: 'default'} }} <a href="" (click)="hsLayoutService.setMainPanel('layermanager', 'default');$event.preventDefault();">{{'ADJUSTER.layerManagerLinkLMName' | translateHs: {app: 'default'} }}</a>
    </div>
  </div>
</div>
